import React, { Component } from "react";
import Multiselect from 'react-widgets/lib/Multiselect'
import 'react-widgets/dist/css/react-widgets.css'
import InputMask from "react-input-mask";
const isEmpty = require("is-empty");


class UserAccessModalComponent extends Component {

	///---------------------------------------INIT-------------------------------------

	state = {
		roles:[],
		faculties:[],
		denies:[],
		errorRoles:""
	};

	constructor(props) {
		super(props);
		this.onPressEsc = this.onPressEsc.bind(this);
	}


	componentDidUpdate(prev) {
		document.addEventListener('keydown', this.onPressEsc, false);
		if (this.props.user) {

			if (this.props.user !== prev.user || this.state.roles.length === 0) {
				let newState = {
					roles: this.props.user.roles,
					faculties: this.props.user.faculties,
					denies: this.props.user.denies
				}
				this.setState(newState)
			}
		}
	}


	///---------------------------------------EVENTS-------------------------------------

	onPressEsc(event) {
		if (event.keyCode === 27) {
			this.onPressCancel();
		}
	}

	clearErrors() {
		this.setState({
			errorRoles: ""
		})
	}

	async preparateUpdate() {
		this.clearErrors()
		let isValid = this.validate()

		if (isValid) {
			let user = this.props.user;
			user.roles = this.state.roles;
			user.denies = this.state.denies;
			user.faculties = this.state.faculties;
			this.props.handleUpdate(user);
			this.farmazonFormRef.reset()

			this.setState({
				roles:[],
				faculties:[],
				denies:[],
				errorRoles:""
			})
		}
	}


	cleanForm() {
		this.farmazonFormRef.reset()
		this.setState({
			roles:[],
			faculties:[],
			denies:[]
		});
	}

	validate() {
		if (this.state.roles.length === 0) {
			this.setState({
				errorRoles: "El usuario debe tener al menos un rol."
			})
			return false;
		} 
		return true;
	}

	onPressCancel() {
		this.farmazonFormRef.reset()
		this.setState({
			roles:[],
			faculties:[],
			denies:[]
		}, () => {
			this.props.handleCancel()
		})
	}

	onChangeRole(roles) {
		let keys = [];
		for (let rol of roles) {
			keys.push(rol.key);
		}
		this.setState({
			roles: keys
		})
	}

	onChangeFaculty(faculties) {
		let keys = [];
		for (let faculty of faculties) {
			keys.push(faculty.key);
		}
		this.setState({
			faculties: keys
		})
	}

	onChangeDeny(denies) {
		let keys = [];
		for (let deny of denies) {
			keys.push(deny.key);
		}
		this.setState({
			denies: keys
		})
	}

	///---------------------------------------VIEW-------------------------------------

	render() {

		let title = "ACCESOS"

		return (
			<div className={this.props.isVisible ? "modal display-block" : "modal display-none"}>
				<div className="modal-user-main">
					<div className="auth-group">
						{title}
						<div className="auth-label"></div>
						<div className="auth-label"></div>
						<form ref={(el) => { this.farmazonFormRef = el }}>
			
	
							{	this.state.roles && this.props.roles  &&	
								<div className="row-multiselect-roles">
									Roles
									<span className="required"> * </span>
									<Multiselect
										placeholder="Roles"
										form={"form"}
										data={this.props.roles}
										valueField="key"
										dataKey="key"
										textField="name"
										value={this.state.roles}
										error={this.state.errorRoles}
										onChange={this.onChangeRole.bind(this)}
									/>
								</div>
							}
							
							<div className="auth-error">
								{this.state.errorRoles}
							</div>

							{ this.state.faculties && this.props.faculties  &&
								<div className="row-multiselect-roles">
									Permisos
									<Multiselect
										placeholder="Permisos"
										form={"form"}
										data={this.props.faculties}
										valueField="key"
										dataKey="key"
										textField="name"
										value={this.state.faculties}
										onChange={this.onChangeFaculty.bind(this)}
									/>
								</div>
							}
							<div className="auth-label"></div>
							{
								<div className="row-multiselect-roles">
									Denegaciones
									<Multiselect
										placeholder="Denegaciones"
										form={"form"}
										data={this.props.denies}
										valueField="key"
										dataKey="key"
										textField="name"
										value={this.state.denies}
										onChange={this.onChangeDeny.bind(this)}
									/>
								</div>
							}
							
							<div className="auth-label"></div>
							<div className="auth-label"></div>
							<div className="auth-error">
								{this.props.error}
							</div>
						</form>
						<div className="modal-activity-section">
							{
								this.props.type === 'UPDATE' &&
								<button className="modal-buttonOK" onClick={this.preparateUpdate.bind(this)}>ACTUALIZAR</button>
							}
							{
								<button className="modal-buttonNo" onClick={this.onPressCancel.bind(this)}>CERRAR</button>
							}
						</div>
					</div>
				</div>
			</div>
		)

	}
}

export default UserAccessModalComponent;
